import type { SelfEmployedPayoutMethod } from '@/shared/api'

export const editValidate = (
    saved: SelfEmployedPayoutMethod,
    current: SelfEmployedPayoutMethod,
    isValid: boolean,
) => {
    return (
        (saved.bank_id !== current.bank_id ||
            saved.phone !== current.phone ||
            saved.email !== current.email) &&
        isValid
    )
}
